// extracted by css-extract-rspack-plugin
module.exports =  {"termsFrameContent":"TermsModal__termsFrameContent___UeCdG"};